function makeDefaultPromise(to, from, savedPosition) {
    const nuxtApp = useNuxtApp()
    return new Promise((resolve) => {
        nuxtApp.hooks.hookOnce('page:finish', () => {
            // setTimeout(() => {
            //     console.log('page:finish')
            //     resolve({ top: 0 })
            // }, 800)
            //             // alert('wow')
            if (savedPosition) {
            //                 // console.log('page:finish savedPosition')
                resolve(savedPosition)
            //                 // resolve({ top: 0 });
            }
            //             else if (to.hash) {
            //                 setTimeout(() => {
            //                     const targetElement = to.hash ? document.querySelector(to.hash) : null
            //                     lenisScrollTo(targetElement)
            //                 }, 2000) // 1195ms = duration of page transition in app.vue so that the swap of content is not visible
            //                 setTimeout(() => {
            //                     // console.log('page:finish top: 0')
            //                     resolve({ top: 0 })
            //                 }, 1195) // 1195ms = duration of page transition in app.vue so that the swap of content is not visible
            //             }
            else {
                setTimeout(() => {
                    //                     // console.log('page:finish top: 0')
                    resolve({ top: 0 })
                }, 600) // 1195ms = duration of page transition in app.vue so that the swap of content is not visible
            }
        })
    })
}

export default {
    scrollBehavior(to, from, savedPosition) {
        // First check if we're on the same page to scroll right away
        if ((to.path === from.path && to.hash) || (savedPosition && to.hash)) {
            const targetElement = to.hash ? document.querySelector(to.hash) : null
            return new Promise((next) => {
                // console.log('same page scroll scrollBehavior')
                lenisScrollTo(targetElement, {
                    onComplete: next,
                })
            })
        }
        // return { top: 0 }
        return makeDefaultPromise(to, from, savedPosition)
    },
}
